import { FC } from 'react';
import { Button } from '@robocorp/components';
import { IconTrash } from '@robocorp/icons/iconic';
import { WorkItemFile as WorkItemFileType } from '~/types/resources';
import { useWorkItemDownloadLinkMutation } from '~/queries';
import BytesToFileSize from '~/components/BytesToFileSize';
import { FileList } from '~/components';

type RowData = Omit<WorkItemFileType, 'id'> & { index: number; id?: WorkItemFileType['id'] };

interface RowProps {
  workItemId: string;
  remove?: (index: number) => void;
}

export const WorkItemFile: FC<RowData & RowProps> = ({
  id,
  size,
  name,
  workItemId,
  remove,
  index,
}) => {
  const { mutateAsync: getWorkItemDownloadLinkMutation } = useWorkItemDownloadLinkMutation();

  const onClick = async () => {
    const downloadLinkBody = await getWorkItemDownloadLinkMutation({
      workItemId: workItemId as string,
      fileId: id as string,
    });
    if (downloadLinkBody) {
      const a = document.createElement('a');

      a.href = downloadLinkBody.url || '';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  /**
   * Allow to re-download only uploaded files
   */
  const onRowClick = id ? onClick : () => null;

  return (
    <FileList.File fileName={name} fileSize={<BytesToFileSize bytes={size} />} onClick={onRowClick}>
      {!!remove && (
        <Button
          icon={IconTrash}
          onClick={() => remove?.(index)}
          variant="ghost"
          aria-label="delete"
        />
      )}
    </FileList.File>
  );
};
